'use client'

import { PostcodePopUp, useRegisterDeliveryInformationFormState } from '@features/delivery'
import { useTranslation } from '@shared/config/i18n'
import { UI_IDS } from '@shared/constants'
import React, { useState } from 'react'

import { ButtonV1, HStack, Input, Typography, VStack } from '@podo-app/design-system-temp'

const RegisterDeliveryInformationForm = ({ readOnly = false }: { readOnly?: boolean } = {}) => {
  const t = useTranslation()
  const [isOpenPostcode, setIsOpenPostcode] = useState(false)
  const { formState, handleChange } = useRegisterDeliveryInformationFormState()

  return (
    <React.Fragment>
      <VStack as="form" className="gap-4">
        <VStack className="gap-2">
          <label htmlFor="name" aria-label={t('delivery.form.recipientName')}>
            <Typography size="h6" className="text-gray-400">
              {t('delivery.form.recipientName')}
            </Typography>
          </label>
          <Input
            disabled={readOnly}
            className="w-full"
            name="name"
            value={formState.values?.name}
            onChange={(event) => handleChange('name', event.target.value)}
          />
        </VStack>

        <VStack className="gap-2">
          <label htmlFor="phone" aria-label={t('delivery.form.phone')}>
            <Typography size="h6" className="text-gray-400">
              {t('delivery.form.phone')}
            </Typography>
          </label>
          <Input
            disabled={readOnly}
            className="w-full"
            name="phone"
            value={formState.values?.phone}
            onChange={(event) => handleChange('phone', event.target.value)}
          />
        </VStack>

        <VStack className="gap-2">
          <label htmlFor="address" aria-label={t('delivery.form.address')}>
            <Typography size="h6" className="text-gray-400">
              {t('delivery.form.address')}
            </Typography>
          </label>
          <HStack className="gap-2.5">
            <Input
              disabled={readOnly}
              className="w-full"
              name="zipCode"
              placeholder={t('delivery.form.zipCode')}
              value={formState.values.zipCode}
              onChange={(event) => handleChange('zipCode', event.target.value)}
              readOnly
            />
            <ButtonV1
              disabled={readOnly}
              variant="sub"
              size="xLarge"
              className="bg-gray-900 text-white"
              type="button"
              onClick={() => setIsOpenPostcode(true)}
              eventParams={{ name: UI_IDS.btn.searchAddress, location: 'delivery', action: 'open' }}
            >
              {t('delivery.form.searchAddress')}
            </ButtonV1>
          </HStack>

          <Input
            disabled={readOnly}
            className="w-full"
            name="address"
            placeholder={t('delivery.form.address')}
            value={formState.values.address}
            readOnly
          />
          <Input
            disabled={readOnly}
            className="w-full"
            name="detailAddress"
            placeholder={t('delivery.form.detailAddressPlaceholder')}
            value={formState.values.detailAddress}
            onChange={(event) => handleChange('detailAddress', event.target.value)}
          />
        </VStack>
      </VStack>
      {isOpenPostcode && <PostcodePopUp handleChange={handleChange} close={() => setIsOpenPostcode(false)} />}
    </React.Fragment>
  )
}

export default RegisterDeliveryInformationForm
